<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/buOrderListWHuo')">代理活跃度统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          
          <el-form-item label="统计类型">
              <el-select  v-model="filters.userType" placeholder="请选择">
                <el-option label="董事" value="4.2"></el-option>
                <el-option label="区域总监" value="5.1"></el-option>
                <el-option label="城市加盟商" value="5.2"></el-option>

                <el-option label="经销商" value="4.8"></el-option>
                <el-option label="康减系列vip会员" value="-0.5"></el-option>
                <el-option label="康减系列高级会员" value="-0.4"></el-option>
                <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                <el-option label="康减系列市代" value="1.1"></el-option>
                <el-option label="康减系列省代" value="2.1"></el-option>
                <el-option label="康减系列CEO" value="3.1"></el-option>

                <el-option label="VIP门店" value="0"></el-option>
                <el-option label="联盟店" value="1"></el-option>
                <el-option label="优秀联盟店" value="1.05"></el-option>
                <el-option label="市代" value="2"></el-option>
                <el-option label="省代" value="3"></el-option>
                <el-option label="CEO" value="4"></el-option>
                <el-option label="总经销商" value="5"></el-option>
                <el-option label="销售公司" value="6"></el-option>
                <el-option label="合伙人" value="2.2"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item label='代理手机号'>
            <el-input
              v-model="filters.username"
              placeholder="代理手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item label="邀请类型">
              <el-select  v-model="filters.invite_user_type" placeholder="请选择" clearable>
                <el-option label="董事" value="4.2"></el-option>
                <el-option label="联盟店" value="1"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut3"
              type="primary"
              size="small"
            >导出</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出邀请人数统计</el-button>

            <el-tooltip class="item" effect="light" content="导出要董事或者区总的购进补货金额" placement="top-start">
            <el-button
              style="margin-left:10px"
              @click="excelOut1"
              type="primary"
              size="small"
            >导出购进补货金额</el-button>
        </el-tooltip>

            <el-tooltip class="item" effect="light" content="董事是指直属下级购货金额，区总是区域下面的代理购货金额" placement="top-start">
              <el-button
                style="margin-left:10px"
                @click="excelOut2"
                type="primary"
                size="small"
              >导出批发销售</el-button>
            </el-tooltip>
            

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 800px;max-width: 300px"
                  :src="scope.row.user_head"
                />
                <img
                  slot="reference"
                  :src="scope.row.user_head"
                  :alt="scope.row.user_head"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>

            </template>
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            prop="roleTypeName"
            label="代理级别"
          >
          </el-table-column>

          <el-table-column
            prop="r_create_time"
            label="升级时间"
          >
          </el-table-column>

          <el-table-column
            prop="province"
            label="省"
          >
          </el-table-column>

          <el-table-column
            prop="city"
            label="市"
          >
          </el-table-column>

          <el-table-column
            prop="district"
            label="区"
          >
          </el-table-column>

          


          
        </el-table>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {
  },
  data() {
    return {
      picList:[],
      subListVisible:false,
      dialogAddVisible:false,
      filters: {
        username:null,
        userType:'4.2',
        invite_user_type:null,
        roleType: null,
        endTime: null,
        startTime:null,
        status:null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableDetailData:[],
      detailListLoading:false,
      tableHeight:null,
      page_num1: 1,
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    formatterRoleType(row, column) {
      var word = "";
      if (row.infoType == 1) {
        word = "每日打卡获得";
      } else if (row.infoType == 2) {
        return "连续一周获得";
      } else if (row.infoType == 3) {
        return "连续一个月";
      } else if (row.infoType == 4) {
        return "连续一个季度";
      }
      return word;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/top_invite_di_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.invite_user_type) {
        url = url + "&invite_user_type=" + that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if(that.filters.userType){
      if(that.filters.userType >= 4.2){
        top.location.href = url + "&userType=" + that.filters.userType;
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择董事以上代理级别',
          duration: 2000
        });
        return;
      }}
    },

    excelOut1() {
      var that = this;
      var url =
        "/manager/user/pc/top_buy_money_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.inviteUserType) {
        url = url + "&invite_user_type=" + that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      top.location.href = url  + "&userType=" + that.filters.userType;
    },

    excelOut3() {
      var that = this;
      var url =
        "/manager/user/pc/head_invite_user_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.username && that.filters.username != '') {
        url = url + "&telephone=" + that.filters.username;
      }  else
      {
        that.$message.error({
          showClose: true,
          message: '请输入手机号',
          duration: 2000
        });
        return;
      }
      
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.invite_user_type) {
        url = url + "&invite_user_type=" + that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if(that.filters.userType){
      if(that.filters.userType >= 4.2){
        top.location.href = url  + "&userType=" + that.filters.userType;
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择董事以上代理级别',
          duration: 2000
        });
        return;
      }}
    },

    excelOut2() {
      var that = this;
      var url =
        "/manager/user/pc/top_sale_money_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.inviteUserType) {
        url = url + "&invite_user_type=" + that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if(that.filters.userType){
      if(that.filters.userType >= 4.2){
        top.location.href = url  + "&userType=" + that.filters.userType;
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择董事以上代理级别',
          duration: 2000
        });
        return;
      }}
    },

     addPostDialog() {
      this.$router.push({
        path: "/addCourse"
      });
    },
    editPostDialog(row) {
      this.$router.push({
        path: "/addCourse",
        query: {
          good: row
        }
      });
    },
    upHouseStatus(row) {
      this.$router.push({ path: "/cardMp3List", query: { userId: row.id } });
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    showSecond(row){
      this.picList = row.content.split(',');
      console.info(this.picList);
      this.dialogAddVisible = true;
    },
    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
      };
      if(that.filters.userType >= 4.2){
        params.userType = that.filters.userType
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择董事以上代理级别',
          duration: 2000
        });
        return;
      }
      if (that.filters.username && that.filters.username != '') {
        params.telephone = that.filters.username;
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请输入手机号',
          duration: 2000
        });
        return;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.invite_user_type) {
        params.invite_user_type = that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      that.loading = true;
      API.head_invite_user(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {

              }
              that.tableData = result.result.list;
            } else {
              that.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000
            });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic{
    width: 100%;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
    height: 80vh;
    overflow: hidden;
    overflow-y: auto;
}
.shop-pic img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/buOrderListWHuo.vue